import { takeEvery, call, put, fork } from "redux-saga/effects";
import * as actions from "../actions/AutonomousMaintenanceDetailActions";
import * as api from "../../api/AutonomousMaintenanceDetailApi";
import { showSuccessSnackbar, showErrorSnackbar } from "../actions/SnackbarActions";
import { setBackdrop, resetBackdrop } from "../actions/BackdropActions";
import { getFilesFromZip } from "../../common";

function* setTaskDetailById(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.setTaskDetailById(action.payload);
        yield put(actions.setTaskDetailById(data || undefined));
    } catch (error) {
        yield put(actions.setTaskDetailById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getSameLevelListById(action) {
    console.log({ action });
    try {
        const { data } = yield api.getSameLevelListById(action.payload);
        yield put(actions.setSameLevelListById(data || undefined));
    } catch (error) {
        yield put(actions.setSameLevelListById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getbreakdownRootCause(action) {
    try {
        const { data } = yield api.getbreakdownRootCause(action.payload);
        yield put(actions.setbreakdownRootCause(data || undefined));
    } catch (error) {
        yield put(actions.setbreakdownRootCause(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownReasonGroupList(action) {
    try {
        const { data } = yield api.getBreakdownReasonGroupList(action.payload);
        yield put(actions.setBreakdownReasonGroupList(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonGroupList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getBreakdownEffectList(action) {
    try {
        const { data } = yield api.getBreakdownEffectList(action.payload);
        yield put(actions.setBreakdownEffectList(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownEffectList(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getTechnicianListByPoolId(action) {
    try {
        const { data } = yield api.getTechnicianListByPoolId(action.payload);
        yield put(actions.setTechnicianListByPoolId(data || undefined));
    } catch (error) {
        yield put(actions.setTechnicianListByPoolId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* autonomousMaintenanceAssign(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.autonomousMaintenanceAssign(action.payload);
        yield put(actions.setAutonomousMaintenanceAssign(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setAutonomousMaintenanceAssign(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAutonomousMintenance(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.startAutonomousMintenance(action.payload);
        yield put(actions.setStartAutonomousMaintenance(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setStartAutonomousMaintenance(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* autonomousMaintenanceCloaseComplete(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.autonomousMaintenanceCloaseComplete(action.payload);
        yield put(actions.setAutonomousMaintenanceCloaseComplete(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setAutonomousMaintenanceCloaseComplete(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* autonomousMaintenancePause(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.autonomousMaintenancePause(action.payload);
        yield put(actions.setautonomousMaintenancePause(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setautonomousMaintenancePause(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* autonomousMaintenanceUpdateTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.autonomousMaintenanceUpdateTask(action.payload);
        yield put(actions.setautonomousMaintenanceUpdateTask(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setautonomousMaintenanceUpdateTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* AddTechnician(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.AddTechnician(action.payload);
        yield put(actions.setAddTechnician(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setAddTechnician(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* BreakdownReasonPlaceByGroupId(action) {
    try {
        const { data } = yield api.BreakdownReasonPlaceByGroupId(action.payload);
        yield put(actions.setBreakdownReasonPlaceByGroupId(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonPlaceByGroupId(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* BreakdownReasonDetail(action) {
    try {
        const { data } = yield api.BreakdownReasonDetail(action.payload);
        yield put(actions.setBreakdownReasonDetail(data || undefined));
    } catch (error) {
        yield put(actions.setBreakdownReasonDetail(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* getAutonomousFiles(action) {
    try {
        const { data } = yield api.getAutonomousFiles(action.payload);
        const files = yield getFilesFromZip(data);
        yield put(actions.setAutonomousFiles(files || undefined));
    } catch (error) {
        yield put(actions.setAutonomousFiles(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* addAutonomousFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.addAutonomousFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* MaintenancePauseReason(action) {
    try {
        const { data } = yield api.MaintenancePauseReason(action.payload);
        yield put(actions.setMaintenancePauseReason(data || undefined));
    } catch (error) {
        yield put(actions.setMaintenancePauseReason(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}
function* getTaskHistoryById(action) {
    try {
        const { data } = yield api.getTaskHistoryById(action.payload);
        yield put(actions.setTaskHistoryById(data || undefined));
    } catch (error) {
        yield put(actions.setTaskHistoryById(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteTask(action.payload);
        yield put(actions.setDeleteTask(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setDeleteTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* saveTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.saveAutonomousMintenance(action.payload);
        yield put(actions.setSaveTask(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setSaveTask(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* closeTask(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.closeAutonomousMintenance(action.payload);
        yield put(actions.setAutonomousMaintenancePlayOrClose(data || undefined));
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(actions.setAutonomousMaintenancePlayOrClose(undefined));
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* deleteAutonomousFiles(action) {
    yield put(resetBackdrop());
    try {
        const { data } = yield api.deleteAutonomousFiles(action.payload);
        yield put(showSuccessSnackbar(data.message));
    } catch (error) {
        yield put(showErrorSnackbar(error));
    }
    yield put(setBackdrop());
}

function* watchAll() {
    yield takeEvery(actions.Types.GET_AM_TASKS_DETAIL_BY_ID, setTaskDetailById);
    yield takeEvery(actions.Types.GET_SAME_LEVEL_LIST_BY_ID, getSameLevelListById);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_ROOT_CAUSE, getbreakdownRootCause);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_Effect_LIST, getBreakdownEffectList);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_GROUP_LIST, getBreakdownReasonGroupList);
    yield takeEvery(actions.Types.GET_TECHNICAL_LIST_BY_POOL_ID, getTechnicianListByPoolId);
    yield takeEvery(actions.Types.PLAN_MAINTENANCE_ASSIGN_TASK, autonomousMaintenanceAssign);
    yield takeEvery(actions.Types.GET_AUTONOMOUS_MAINTENANCE_PLAY_START, getAutonomousMintenance);
    yield takeEvery(actions.Types.AUTONOMOUS_MAINTENANCE_CLOSE_COMPLETE, autonomousMaintenanceCloaseComplete);
    yield takeEvery(actions.Types.AUTONOMOUS_MAINTENANCE_PAUSE, autonomousMaintenancePause);
    yield takeEvery(actions.Types.AUTONOMOUS_MAINTENANCE_UPDATE_TASK, autonomousMaintenanceUpdateTask);
    yield takeEvery(actions.Types.ADD_TECHNICIANS, AddTechnician);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_BY_GROUP_ID_LIST, BreakdownReasonPlaceByGroupId);
    yield takeEvery(actions.Types.GET_BREAK_DOWN_REASON_DETAIL, BreakdownReasonDetail);
    yield takeEvery(actions.Types.GET_AUTONOMOUS_FILES, getAutonomousFiles);
    yield takeEvery(actions.Types.ADD_AUTONOMOUS_FILES, addAutonomousFiles);
    yield takeEvery(actions.Types.MAINTENANCE_PAUSE_REASON, MaintenancePauseReason);
    yield takeEvery(actions.Types.GET_TRACK_HISTORY_BY_ID, getTaskHistoryById);
    yield takeEvery(actions.Types.DELEET_TASK, deleteTask);
    yield takeEvery(actions.Types.AUTONOMOUS_MAINTENANCE_SAVE, saveTask);
    yield takeEvery(actions.Types.PLAN_MAINTENANCE_PLAY_CLOSE, closeTask);
    yield takeEvery(actions.Types.DELETE_AUTONOMOUS_FILES, deleteAutonomousFiles);
}
const PersonalSummarySaga = [fork(watchAll)];

export default PersonalSummarySaga;
